// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Button from '../Button';
import ButtonGroup from '../ButtonGroup';
import Dropdown from '../Dropdown';

import './SplitButton.less';

/**
 * `Split Button` is a combination of a standard [button](#!/Button) with a [drop-down](#!/Dropdown) menu.
 * It is used for grouping several related actions when one of the actions should be accessible immediately
 * because it is used more often than others.
 */
const SplitButton = ({ baseClassName, className, menu, children, opened, ...props }) => (
    <ButtonGroup className={classNames(baseClassName, className)} {...props}>
        <Button>{children}</Button>
        <Dropdown className={`${baseClassName}__dropdown-trigger`} menu={menu} menuPlacement="bottom-end" />
    </ButtonGroup>
);

SplitButton.propTypes = {
    menu: PropTypes.any,
    opened: PropTypes.bool,
    /**
     * Content of the button group
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

SplitButton.defaultProps = {
    menu: null,
    opened: false,
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}split-button`,
};

export default SplitButton;



// WEBPACK FOOTER //
// ./components/SplitButton/SplitButton.js